import { reducer as createEmailRule } from './createEmailRule'
import { reducer as updateEmailRule } from './updateEmailRule'
import { reducer as getEmailRule } from './getEmailRule'
import { reducer as getEmailRuleList } from './getEmailRuleList'
import { reducer as getOperationsEmailRule } from './getOperationsEmailRule'
import { reducer as getParametersEmailRule } from './getParametersEmailRule'
import { reducer as selectedEmailRule } from './selectedEmailRule'
import { reducer as deleteEmailRule } from './deleteEmailRule'

export default {
  selectedEmailRule,
  getParametersEmailRule,
  getOperationsEmailRule,
  getEmailRuleList,
  getEmailRule,
  updateEmailRule,
  createEmailRule,
  deleteEmailRule
}



// WEBPACK FOOTER //
// ./src/store/email-rules/index.js